export const adminAccount = "admin@hexa.com";
